import React from "react";
import useTranslator from "./use-translator";
import useLocale from "./use-locale";
import useOnLocaleLoaded from "./use-on-locale-loaded";
import {useParameters} from "@morningtrain/react-resources";

export default function useTranslation(name, options = {}, defaultValue = null) {

    const defaultDataRef = React.useRef({});
    const defaultData = defaultDataRef.current;

    const data = useParameters(options.data || defaultData);

    let count = options.count;
    if(!count && count !== 0) {
        if(typeof(data['count']) !== 'undefined') {
            count = data['count'];
        } else {
            count = null;
        }
    }

    const translator = useTranslator();
    const locale = useLocale();

    function translate() {
        return translator.translate(name, {data: data, count: count}, defaultValue);
    }

    const [translation, setTranslation] = React.useState(translate());
    const [currentLocale, setCurrentLocale] = React.useState(locale.get());

    useOnLocaleLoaded((loadedLocale) => {
        setCurrentLocale(loadedLocale);
    });

    React.useEffect(() => {
        if(name === null) {
            return;
        }
        let nextTranslation = translate();
        if (nextTranslation !== translation) {
            setTranslation(nextTranslation);
        }
    }, [name, currentLocale, data, count]);

    return translation;
}
